import Modal from '../../Unknown/Modal'
import { useAppDispatch, useAppSelector } from '../../../modules/store/hooks'
import { modalsSlice } from '../../../modules/store/reducers/modalsSlice'
import { Box, Button, IconButton, Typography } from '@mui/material'
import translate from '../../../i18n/translate'
import { format } from 'date-fns'
import UploadNewOrganizerFileModal from '../UploadNewOrganizerFileModal'
import { organizerApi } from '../../../modules/services/organizerService'
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useState } from 'react'
import PDFReaderModal from '../PDFReaderModal'

export type OrganizerFile = {
  id: number
  name: string
  link: string
  createDate: Date
}

type OrganizerFilesModalProps = {
  organizerFiles: {
    userId: number
    phone: string;
    files: Array<OrganizerFile>
  }
  handleDeleteSuccess: (userId: number, fileId: number) => void;
  handleUploadSuccess: (userId: number, file: OrganizerFile) => void;
}

export default function OrganizerFilesModal({
  organizerFiles,
  handleDeleteSuccess,
  handleUploadSuccess,
}: OrganizerFilesModalProps) {
  const dispatch = useAppDispatch()

  const [viewerLink, setViewerLink] = useState<string>('')
  
  const { toggleOrganizerFilesModal, toggleUploadOrganizerFileModal, togglePdfViewerModal } = modalsSlice.actions
  const visible = useAppSelector(state => state.modalsReducer.organizerFiles)

  const [deleteFile, { isLoading: isDeleteLoading }] = organizerApi.useDeleteOrganizerFileMutation()

  const onCloseModal = () => {
    dispatch(toggleOrganizerFilesModal())
  }

  const handleDeleteFile = async (fileId: number) => {
    try {
      await deleteFile({ userId: organizerFiles.userId, fileId });

      handleDeleteSuccess(organizerFiles.userId, fileId);
    } catch (error) {
      
    }

  }

  const handleUploadFile = async (file: OrganizerFile) => {
    handleUploadSuccess(organizerFiles.userId, file);
  }

  const handleDownloadFile = async (link: string) => {
    window.open(link);
  }

  const handlePreviewFile = async (link: string) => {
    setViewerLink(link)

    dispatch(togglePdfViewerModal())
  }

  return (
    <>
      <Modal
        title={translate('organizerFilesModalTitle')}
        visible={visible === 'open'}
        style={{ maxWidth: '800px' }}
        setVisible={onCloseModal}
      >
        <Box padding={2} display='flex' flexDirection='column' gap={1.5}>
          {organizerFiles.files.map((f) => (
            <Box key={`organizer-file-${f.id}`} display='flex' justifyContent='space-between' alignItems='center'>
              <Typography>{f.name}</Typography>
              <Box display='flex' gap={1.5} justifyContent='space-between' alignItems='center'>
                <Typography>{format(new Date(f.createDate), 'dd/MM/yyyy HH:mm')}</Typography>
                <IconButton
                  size='small'
                  color='warning'
                  onClick={() => handlePreviewFile(f.link)}
                  disabled={isDeleteLoading}
                >
                  <VisibilityIcon />
                </IconButton>
                <IconButton
                  size='small'
                  color='warning'
                  onClick={() => handleDownloadFile(f.link)}
                  disabled={isDeleteLoading}
                >
                  <DownloadIcon />
                </IconButton>
                <IconButton
                  size='small'
                  color='error'
                  onClick={() => handleDeleteFile(f.id)}
                  disabled={isDeleteLoading}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>
          ))}
        </Box>
        <Box display='flex' width={1} mt={2} mb={2} justifyContent='center'>

          <Button onClick={() => dispatch(toggleUploadOrganizerFileModal())} color='warning' variant='outlined'>
            {translate('organizerFilesModalAddFile')}
          </Button>
        </Box>
      </Modal>
      <UploadNewOrganizerFileModal userId={organizerFiles.userId} onSuccess={handleUploadFile} />
      <PDFReaderModal link={viewerLink} />
    </>
  )
}
